import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getStorage } from '../assets/js/util2';

Vue.use(VueI18n);
// 引入各个语言配置文件
import en from './en';
import id from './id';
import zh from './zh';
import th from './th';

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: getStorage('locale') || 'en',
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    zh,
    en,
    id,
    th
  }

})
export default i18n
